import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import CheckoutPriceDetails from "../Checkout/CheckoutPriceDetails";
import { useSelector } from "react-redux";
import BuyNowContainer from "./BuyNowBodyContainer";
import styled from "styled-components";
import BuyNowContainerNew from "./BuyNowNewBodyContainer/BuyNowContainer";
import CheckoutPriceDetailsNew from "../Checkout/CheckoutPriceDetails/CheckoutPriceNew";

const BuyNowNew = () => {
  const buyNow = useSelector((state) => state.buyNow || {});
  const GuestDetails = useSelector((state) => state.userDetails || {});
  const { buyNowData: { cartPriceDetail = {}, shipments = [] } = {} } = buyNow;
  const { isGuest = false } = GuestDetails;

  const BuyNowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  background-color: #f5f5f5;
  min-height: 100vh;

  .rightcomp {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
 
    margin-top: 6rem;
  }

  `



  return (

    <BuyNowContainer>
       <BuyNowContainerNew/>
     <div className="rightcomp">
       <CheckoutPriceDetailsNew  cartPriceDetail={cartPriceDetail} shipmentLen={shipments.length} handleApplyCoupon={() => {}}     />
     </div> 

    </BuyNowContainer>
   
  );
};
export default BuyNowNew;
